
export default {
    album(state) {
        return state.album;
    },
    photoInPackage(state) {
        return state.package
    },
    selected(state) {
        return state.selected;
    },
    photoSelected(state) {
        return state.deliveredImage + state.selected.length;
    },
    isSelected: (state) => (imageId) => {
        if (state.selected.find(image => image == imageId)) {
            return true
        }
        return null;
    },
    price(state) {
        if (state.deliveredImage + state.selected.length > state.package) {
            if (state.deliveredImage >= state.package) {
                return 10 * state.selected.length;
            }
            return 10 * (state.selected.length - (state.package - state.deliveredImage));
        }
        return 0;
    }
}